import { Container } from '@mui/material';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';

function ToolsPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <PageHeader title="Creator tools" description="Tools to help with your creator journey." />
      <EmptyState title="Coming soon" text="This page will contain tools to help with your creator journey." />
    </Container>
  );
}

export default ToolsPage;
